<template>
    <span class="text-danger">
        {{ 10 > parseInt(time / 60) ? '0': undefined }}{{ parseInt(time / 60) }}:{{ 10 > time % 60 ? '0': undefined }}{{ time % 60 }}
    </span>
</template>

<script>
import { toRefs, ref, onMounted, onUnmounted } from '@vue/composition-api'
export default {
    props: {
        seconds: {
            type: Number,
            default: 10
        }
    },
    setup (props, context) {
        const { seconds } = toRefs(props)
        const time = ref(seconds.value)
        const timerId = ref(null)
        const tick = () => {
            time.value--
            if (time.value < 1) {
                stop()
            }
        }
        const start = () => {
            timerId.value = setInterval(tick, 1000)
        }
        const stop = () => {
            clearInterval(timerId.value)
            context.emit('done')
        }
        onMounted(start)
        onUnmounted(stop)
        return {
            time,
            tick,
            start,
            stop
        }
    }
}
</script>

<style>

</style>
